import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { Filter } from '../models/filter.model';
import { Appointment } from '../models/appointment.model';
import { Recommendation } from '../models/recommendation.model';

@Injectable({
    providedIn: 'root'
})
export class RecommendationService {

    constructor(private httpClient: HttpClient) { }

    getOne(id: Number) {
        return this.httpClient.get('api/contacts/' + id).toPromise();
    }

    gridView(filter: Filter) {
        return this.httpClient.post('api/contacts/gridview', filter.data)
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    getTotal(filter: Filter) {
        return this.httpClient.post('api/contacts/gridview', filter.data)
            .pipe(
                map((res: any) => {
                    return res.total;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    adminView(filter: Filter) {
        return this.httpClient.post('api/contacts/adminview', filter.data)
            .pipe(
                map((res: any) => {
                    return res.data;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    createContact(recommendation: Recommendation) {
        return this.httpClient.post('api/contacts/create', recommendation.data).toPromise();
    }

    editContact(recommendation: Recommendation) {
        return this.httpClient.post('api/contacts/edit', recommendation.data).toPromise();
    }

    deleteContact(ids: Array<Number>) {
        return this.httpClient.post('api/contacts/delete', ids).toPromise();
    }

    uploadAgreement(form) {
        return this.httpClient.post('api/contacts/uploadagreement', form)
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    downloadAgreement(id: Number) {
        return this.httpClient.post('api/contacts/downloadagreement', { ContactID: id }, { observe: 'response', responseType: 'blob' }).toPromise();
    }

}